import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';

import { convertObjToArr } from '../../../../../utils';
import Actions from '../../../../../store/ducks/appointments';
import Slot from '../Slot';
import useStyles from './styles';

const ColumnTimeTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { timetable } = useSelector(
    state => state.appointments.schedule.columns,
  );
  const [timeTableRequested, setTimeTableRequested] = useState(false);
  const [timeTableArray, setTimeTableArray] = useState([]);

  useEffect(() => {
    if (!Object.keys(timetable).length && !timeTableRequested) {
      dispatch(Actions.requestScheduleTimeTable());
      setTimeTableRequested(true);
    }
  }, [dispatch, timeTableRequested, timetable]);

  useEffect(() => {
    setTimeTableArray(convertObjToArr(timetable));
  }, [timetable]);

  return (
    <Box className={classes.container}>
      <Box className="schedule-column-hours-content">
        {timeTableArray.map(row => (
          <Slot key={row.id} label>{`${row.startTime} - ${row.endTime}`}</Slot>
        ))}
      </Box>
    </Box>
  );
};

export default ColumnTimeTable;
